<template>
  <div>
    <!-- Hero -->
    <section
      class="org-hero pt-4 d-flex flex-column justify-space-between"
      :style="`background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${ backgroundPath }); background-position: center, center; background-repeat: no-repeat, no-repeat; background-size: cover, cover;`"
    >
      <v-row justify="center">
        <v-col cols="12" sm="10" md="9" lg="9" class="text-center">
          <v-avatar class="org-hero__avatar mb-5">
            <img :src="logoPath" />
          </v-avatar>

          <!-- Name -->
          <h1 class="org-hero__title">{{ organization.name }}</h1>

          <div class="org-details">
            <!-- Industry -->
            <p class="org-hero__text">
              <span v-if="organization.segment && organization.segment !== ''">Industria: {{organization.segment}}</span>
              <span v-if="organization.segment && organization.segment !== '' && organization.employees"> - </span>
              <span v-if="organization.employees">{{ employeeRange }} colaboradores</span>
            </p>

            <!-- Gender commitment -->
            <div v-if="isGenderCommitted" class="org-hero__commitment d-flex flex-column align-center d-sm-block">
              <v-icon color="white" size="16px">mdi-human-female</v-icon>
              <span class="org-hero__text">Organización comprometida con la equidad de género</span>
            </div>

            <!-- Goals -->
            <div class="org-hero__goals">
              <v-tooltip top v-for="goal in goalsToShow" :key="goal">
                <template v-slot:activator="{ on, attrs }">
                  <img v-bind="attrs" v-on="on" class="goal-icon mx-1 pa-0" :src="require(`@/assets/images/goals/${goalsObj[goal-1].img}.webp`)"/>
                </template>
                <span>{{goalsObj[goal - 1].tooltip}}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Hero Bottom -->
      <v-row justify="center" align="end">
        <div class="org-hero__bottom">
          <!-- Location -->
          <p class="org-hero__location mb-2">{{`${getCity}, ${getCountry}`}}</p>

          <!-- Website -->
          <div v-if="organization.networks.web" class="d-flex justify-center align-center mb-2">
            <v-icon class="mr-2" color="white">mdi-web</v-icon>
            <a class="org-hero__website" :href="getWeb" target="_blank">
              {{getWeb}}
            </a>
          </div>

          <!-- Social -->
          <div
            class="org-hero__social"
          >
            <SocialIcon
              :network="organization.networks.facebook"
              tooltip="Facebook"
              icon="mdi-facebook"
            />
            <SocialIcon
              :network="organization.networks.twitter"
              tooltip="Twitter"
              icon="mdi-twitter"
            />
            <SocialIcon
              :network="organization.networks.whatsapp"
              tooltip="WhatsApp"
              icon="mdi-whatsapp"
            />
            <SocialIcon
              :network="organization.networks.linkedin"
              tooltip="LinkedIn"
              icon="mdi-linkedin"
            />
          </div>
        </div>
      </v-row>
    </section>

    <!-- Purpose -->
    <section class="org-purpose">
      <v-container class="py-10">
        <v-row justify="center" v-if="organization.purpose && organization.purpose !== ''">
          <v-col cols="11" sm="11" md="10" lg="9">
            <h2 class="org-purpose__text">{{getInnerText(organization.purpose)}}</h2>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Content -->
    <section class="org-content">
      <v-container>
        <!-- Description -->
        <v-row v-if="organization.description && organization.description !== ''" class="mb-6" justify="center">
            <v-col cols="11" sm="11" md="10" lg="9">
              <v-card class="org-content__card">
                <h3 class="org-content__title mb-6">¿Por qué deberías trabajar acá?</h3>
                <p class="org-content__text" v-html="organization.description"></p>
              </v-card>
            </v-col>
        </v-row>

        <!-- Achievement -->
        <v-row v-if="organization.achievement && organization.achievement !== ''" class="mb-6" justify="center">
          <v-col cols="11" sm="11" md="10" lg="9">
            <v-card class="org-content__card">
              <h3 class="org-content__title mb-6">Estamos orgullosos de lo que hacemos.</h3>
              <p class="org-content__text" v-html="organization.achievement"></p>
            </v-card>
          </v-col>
        </v-row>

        <!-- Video -->
        <v-row v-if="getVideo !== ''" class="py-3" justify="center">
          <v-col cols="11" sm="11" md="10" lg="9">
            <h3 class="org-content__title mb-8">Conócenos un poco más acá.</h3>
            <iframe
              width="100%"
              :height="videoHeight"
              :src="getVideo"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-col>
        </v-row>
        <!-- <v-row v-if="false" class="py-3" justify="center">
            <v-col cols="11" sm="11">
              <h2 class="txt-blue text-center">
                Ups! {{ organization.name }} no tiene su perfil completo.
              </h2>
            </v-col>
        </v-row> -->
      </v-container>
    </section>

    <!-- Org offers -->
    <section v-if="view === 'full'" class="org-offers pb-10">
      <OffersList title="Publicaciones activas" class="my-10" :filter="organization.name" tags=""/>
      <v-container class="pt-0">
        <v-row justify="center">
          <v-btn class="org-offers__btn" :to="{name: 'Home'}" style="background-color: #3BADFF;" x-large>
            VER TODAS LAS OFERTAS DE TRABAJO
          </v-btn>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
import OffersList from "@/components/OffersList";
import SocialIcon from "@/components/SocialIcon";

export default {
    name: "OrganizationInfo",

    components: { OffersList, SocialIcon },

    props: ["view", "organization"],

    data() {
        return {
            goalsObj: [
                { tooltip: "Fin a la Pobreza", img: "goal-01" },
                { tooltip: "Hambre cero", img: "goal-02" },
                { tooltip: "Salud y bienestar", img: "goal-03" },
                { tooltip: "Educación de calidad", img: "goal-04" },
                { tooltip: "Igualdad de género", img: "goal-05" },
                { tooltip: "Agua limpia y saneamiento", img: "goal-06" },
                { tooltip: "Energía asequible y no contaminante", img: "goal-07" },
                { tooltip: "Trabajo decente y crecimiento económico", img: "goal-08" },
                { tooltip: "Industria, innovación e infraestructura", img: "goal-09" },
                { tooltip: "Reducción de las desigualdades", img: "goal-10" },
                { tooltip: "Ciudades y comunidades sostenibles", img: "goal-11" },
                { tooltip: "Producción y consumo responsables", img: "goal-12" },
                { tooltip: "Acción por el clima", img: "goal-13" },
                { tooltip: "Vida submarina", img: "goal-14" },
                { tooltip: "Vida de ecosistemas terrestres", img: "goal-15" },
                { tooltip: "Paz, justicia e instituciones sólidas", img: "goal-16" },
                { tooltip: "Alianzas para lograr objetivos", img: "goal-17" }
            ],
        };
    },

    computed: {
        employeeRange() {
            // organization.employees.length === 0 ? "1 a 10" : `${organization.employees[0]} a ${organization.employees[1]}`
            if (this.organization.employees.length === 0) {
                return "1 a 10";
            } else if (this.organization.employees[0] >= 100) {
                return "+100";
            } else {
                return `${this.organization.employees[0]} a ${this.organization.employees[1]}`;
            }
        },
        getWeb() {
            return this.organization.networks.web.includes("http") ? this.organization.networks.web : `https://${this.organization.networks.web}` ;
        },
        getCity() {
            const city = this.organization.city;
            return city.substring(0, city.indexOf("(") - 1);
        },

        getCountry() {
            const city = this.organization.city;
            return city.substring(city.indexOf("(") + 1, city.indexOf(")"));
        },

        getVideo() {
            let video = this.organization.media.video || this.organization.video || "";   //"https://www.youtube.com/watch?v=7cSbjf5GVFg";
            let url = video;
            if (video.includes("youtube")) {
                url = `https://www.youtube.com/embed/${video.substring(video.indexOf("=") + 1, video.length)}?picture-in-picture=1&accelerometer=1&gyroscope=1`;
            }
            if (video.includes("vimeo")) {
                url = `https://player.vimeo.com/video/${video.substring(video.length - 9, video.length)}`;
            }
            if (!video.includes("http") && video !== "") {
                url = `http://${video}`;
            }
            return url;
        },

        goalsToShow() {
            return this.organization.goals.slice(0, 4);
        },

        isGenderCommitted() {
            // TODO: Manejar caso en que "No"
            const commitment = this.organization.gender.split(",");
            return commitment[0] === "Sí" ? true : false;
        },

        backgroundPath() {
            let path = "";
            if (this.organization.media.cover && this.organization.media.cover != "") {
                path = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_COVER_PATH + (this.organization.cover || this.organization.media.cover);
            }
            return path;
        },

        logoPath() {
            let path = require("@/assets/images/avatar-default-icon.webp");
            if (this.organization.media.logo && this.organization.media.logo != "") {
                path = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_LOGO_PATH + (this.organization.logo || this.organization.media.logo);
            }
            return path;
        },

        videoHeight() {
            return this.$vuetify.breakpoint.smAndUp ? 450 : 190;
        }
    },

    methods: {
        getInnerText(html) {
            let temp = document.createElement("div");
            temp.innerHTML = html;
            return temp.textContent || temp.innerText || "";
        },
    }
};
</script>

<style>

</style>
